export default '/src/assets/webgl/caris_2/audios/outro.mp3'